import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useToast } from "@/hooks/use-toast";
import { archiveAgent } from "@/services/templateService";

export const useArchiveAgent = () => {
  const [isArchiving, setIsArchiving] = useState(false);
  const { organization } = useAuth();
  const { toast } = useToast();

  const archive = async (agentId: string) => {
    if (isArchiving) return false;
    
    if (!organization?.id) {
      toast({
        variant: "destructive",
        title: "Organization required",
        description: "No organization found for archiving agent",
      });
      return false;
    }

    setIsArchiving(true);
    try {
      const { error } = await archiveAgent(agentId, organization.id);
      
      if (error) {
        throw error;
      }

      toast({
        title: "Agent archived",
        description: "The agent has been archived successfully",
      });

      return true;
    } catch (error: any) {
      console.error("Error archiving agent:", error);
      toast({
        variant: "destructive",
        title: "Failed to archive agent",
        description: error.message || "An unexpected error occurred",
      });
      return false;
    } finally {
      setIsArchiving(false);
    }
  };

  return { archive, isArchiving };
}; 